import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface OverlapWarningModalProps {
  open: boolean;
  onClose: () => void;
}

export function OverlapWarningModal({ open, onClose }: OverlapWarningModalProps) {
  const { t } = useTranslation('authenticated.planner', {
    keyPrefix: 'modals.overlapWarningModal',
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader className="space-y-2">
          <DialogTitle className="mb-2">{t('title')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('description')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button>{t('confirm')}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
